"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeasonTypeEnum = exports.SeasonSaleTaxEnum = exports.SendQRCodeEnum = exports.SeasonTaxDeductionEnum = exports.SeasonAgeEnum = void 0;
// export enum SeasonTypeEnum {
//   GeneralEvent = "General Event", // TODO // BACKFILL
//   Concert = "Concert",
// }
var SeasonAgeEnum;
(function (SeasonAgeEnum) {
    SeasonAgeEnum["AllAges"] = "All ages welcome";
    SeasonAgeEnum["EighteenPlus"] = "18+";
    SeasonAgeEnum["TwentyOnePlus"] = "21+";
})(SeasonAgeEnum = exports.SeasonAgeEnum || (exports.SeasonAgeEnum = {}));
var SeasonTaxDeductionEnum;
(function (SeasonTaxDeductionEnum) {
    SeasonTaxDeductionEnum["false"] = "No";
    SeasonTaxDeductionEnum["true"] = "Yes";
})(SeasonTaxDeductionEnum = exports.SeasonTaxDeductionEnum || (exports.SeasonTaxDeductionEnum = {}));
var SendQRCodeEnum;
(function (SendQRCodeEnum) {
    SendQRCodeEnum["UponOrder"] = "Upon order";
    SendQRCodeEnum["TwoWeeksBefore"] = "Two weeks before show";
    SendQRCodeEnum["DayOfShow"] = "Day of Show";
})(SendQRCodeEnum = exports.SendQRCodeEnum || (exports.SendQRCodeEnum = {}));
var SeasonSaleTaxEnum;
(function (SeasonSaleTaxEnum) {
    SeasonSaleTaxEnum["SalesTax"] = "Sales tax";
})(SeasonSaleTaxEnum = exports.SeasonSaleTaxEnum || (exports.SeasonSaleTaxEnum = {}));
var SeasonTypeEnum;
(function (SeasonTypeEnum) {
    SeasonTypeEnum["GeneralEvent"] = "General Event";
    SeasonTypeEnum["Concert"] = "Concert";
})(SeasonTypeEnum = exports.SeasonTypeEnum || (exports.SeasonTypeEnum = {}));
//# sourceMappingURL=ISeason.js.map